import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bristolConfig } from "./data";

export default function BristolPage() {
  return <CityPageTemplate config={bristolConfig} />;
}